export default {"src":"/_next/static/image/src/assets/icons/filter-icons/garden.b7f0cef3445048857885162f58a779b5.svg","height":32,"width":40};